export default __webpack_public_path__ + "static/media/2248.34ac6377.svg";